"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// tslint:disable:no-shadowed-variable
var $dyn;
(function ($dyn) {
    var util;
    (function (util) {
        // override _gotoToday so that it goes to the localized day
        $.datepicker._gotoToday = function (id) {
            var target = $(id);
            var inst = this._getInst(target[0]);
            if (this._get(inst, "gotoCurrent") && inst.currentDay) {
                inst.selectedDay = inst.currentDay;
                inst.drawMonth = inst.selectedMonth = inst.currentMonth;
                inst.drawYear = inst.selectedYear = inst.currentYear;
            }
            else {
                var date_1 = inst.settings.localToday || new Date();
                inst.selectedDay = date_1.getDate();
                inst.drawMonth = inst.selectedMonth = date_1.getMonth();
                inst.drawYear = inst.selectedYear = date_1.getFullYear();
            }
            this._notifyChange(inst);
            this._adjustDate(target);
        };
        // This is the default value for moment currently
        var shortYearCutoff = 68;
        // If two digit year is above 68 assume this is for 1900 otherwise 2000
        moment.parseTwoDigitYear = function (yearString) {
            var yearAsInt = parseInt(yearString, 10);
            return yearAsInt + (yearAsInt > shortYearCutoff ? 1900 : 2000);
        };
        // Make sure the 'User' timezone always exists.
        // Real zone data should be loaded when the session information comes down.
        moment.tz.add("User|UST|0|0|");
        // Update moment with Month and Day names from Globalize
        var currentGlobalizeCulture = Globalize.culture();
        moment.updateLocale(moment.locale(), {
            months: currentGlobalizeCulture.calendar.months.names,
            monthsShort: currentGlobalizeCulture.calendar.months.namesAbbr,
            weekdays: currentGlobalizeCulture.calendar.days.names,
            weekdaysMin: currentGlobalizeCulture.calendar.days.namesShort,
            weekdaysShort: currentGlobalizeCulture.calendar.days.namesAbbr,
        });
        /**
         * The time helper namespace.
         */
        var time;
        (function (time) {
            /** The min date for our system */
            time.minDate = new Date(Date.UTC(1900, 0, 1, 0, 0, 0, 0));
            /** The max date for our system */
            time.maxDate = new Date(Date.UTC(2154, 11, 31, 23, 59, 59, 0));
        })(time = util.time || (util.time = {}));
        /**
         * Formats a value for use with the date control
         * @param dateTime The date object we need to format
         * @returns The formatted date string
         */
        function dateValue(dateTime) {
            return Globalize.format(dateTime, "yyyy-MM-dd");
        }
        util.dateValue = dateValue;
        /**
         * Formats a value for use with the dateTime control
         * @param dateTime The dateTime object we need to format
         * @returns The formatted dateTime string
         */
        function dateTimeValue(dateTime) {
            return Globalize.format(dateTime, "yyyy-MM-ddTHH:mm:ss");
        }
        util.dateTimeValue = dateTimeValue;
        /**
         * Combines the date and time of two moment objects
         * @param dateSource The moment object to get the date from
         * @param timeSource The moment object to get the time from
         * @returns The combined moment object
         */
        function combineDateAndTime(dateSource, timeSource) {
            if (moment.isMoment(dateSource) && dateSource.isValid()) {
                if (moment.isMoment(timeSource) && timeSource.isValid()) {
                    // set only the time portion of the date
                    dateSource.hours(timeSource.hours());
                    dateSource.minutes(timeSource.minutes());
                    dateSource.seconds(timeSource.seconds());
                }
            }
            return dateSource;
        }
        util.combineDateAndTime = combineDateAndTime;
        /**
         * Retrieves date format information for the specified control
         * @param control The specified control
         * @returns An object containing display and parse formats.
         * @remarks
         * The display format is a simple string,
         * but the parse format is an array of possible formats to try when parsing.
         *
         * Uses the date specific properties of the control to create a format patterns
         * for the specified control to be used by moment.js for formatting the time.
         * Also creates a datePickerFormatPattern property on the specified control to be
         * used by the jQueryUI date picker.
         */
        function getDateFormat(control) {
            // Note that moment, Globalize, and jQuery all represent dates format strings differently,
            // here is a handy chart of the format strings.
            // | Type            | Moment    | Globalize | jQuery |
            // |-----------------|-----------|-----------|--------|
            // | 4 digit year    | YYYY      | yyyy      | yy     |
            // | 2 digit year    | YY        | yy        | y      |
            // | Day as number   | D,DD      | d, dd     | d, dd  |
            // | Day as name     | ddd, dddd | ddd, dddd | D, DD  |
            // | Month as number | M, MM     | M, MM     | m, mm  |
            // | Month as name   | MMM, MMMM | MMM, MMMM | M, MM  |
            // |                 |           |           |        |
            // | Hour as 24      | H,HH      | H, HH     |        |
            // | Hour as 12      | h, hh     | h, hh     |        |
            // | Minutes         | m, mm     | m, mm     |        |
            // | Seconds         | s, ss     | s, ss     |        |
            // | AM/PM           | A, a      | t, tt     |        |
            var getCultureDefaults = function () {
                var culture = Globalize.culture();
                var shortDateFormatPattern = culture.calendar.patterns.d;
                var cultureFormatPatternParts = shortDateFormatPattern.split(culture.calendar["/"]);
                var cultureDefaultDayAs;
                var cultureDefaultMonthAs;
                var cultureDefaultYearAs;
                var cultureDefaultDateFormat;
                if (cultureFormatPatternParts) {
                    var controlDateFormatParts = new Array(3);
                    for (var i = 0; i < cultureFormatPatternParts.length; i++) {
                        var patternPart = cultureFormatPatternParts[i];
                        var firstCharacter = patternPart.substr(0, 1).toLowerCase();
                        switch (firstCharacter) {
                            case "d":
                                cultureDefaultDayAs = patternPart;
                                // We only want digit version for the default, so don't let long names be part of the format.
                                cultureDefaultDayAs = cultureDefaultDayAs.substr(0, 2).toUpperCase();
                                controlDateFormatParts[i] = firstCharacter;
                                break;
                            case "m":
                                cultureDefaultMonthAs = patternPart;
                                controlDateFormatParts[i] = firstCharacter;
                                break;
                            case "y":
                                // Globalize culture information uses lower case, but moment format string need upper case.
                                cultureDefaultYearAs = patternPart.toUpperCase();
                                controlDateFormatParts[i] = firstCharacter;
                                break;
                        }
                    }
                    cultureDefaultDateFormat = controlDateFormatParts.join("");
                }
                return {
                    dateFormat: cultureDefaultDateFormat,
                    dateSeparators: [culture.calendar["/"], culture.calendar["/"]],
                    dayAs: cultureDefaultDayAs,
                    monthAs: cultureDefaultMonthAs,
                    yearAs: cultureDefaultYearAs
                };
            };
            var calculateDayFormat = function (formatInfo) {
                if ($dyn.value(control.DateDay)) {
                    switch ($dyn.value(control.DateDay).toLowerCase()) {
                        case "none":
                            formatInfo.dayAs = "";
                            break;
                        case "digits1or2":
                            formatInfo.dayAs = "D";
                            break;
                        case "digits2":
                            formatInfo.dayAs = "DD";
                            break;
                    }
                }
            };
            var calculateMonthFormat = function (formatInfo) {
                if ($dyn.value(control.DateMonth)) {
                    switch ($dyn.value(control.DateMonth).toLowerCase()) {
                        case "none":
                            formatInfo.monthAs = "";
                            break;
                        case "digits1or2":
                            formatInfo.monthAs = "M";
                            break;
                        case "digits2":
                            formatInfo.monthAs = "MM";
                            break;
                        case "short":
                            formatInfo.monthAs = "MMM";
                            break;
                        case "long":
                            formatInfo.monthAs = "MMMM";
                            break;
                    }
                }
            };
            var calculateYearFormat = function (formatInfo) {
                if ($dyn.value(control.DateYear)) {
                    switch ($dyn.value(control.DateYear).toLowerCase()) {
                        case "none":
                            formatInfo.yearAs = "";
                            break;
                        case "digits2":
                            formatInfo.yearAs = "YY";
                            break;
                        case "digits4":
                            formatInfo.yearAs = "YYYY";
                            break;
                    }
                }
            };
            var calculateDateFormat = function (formatInfo) {
                if ($dyn.value(control.DateFormat)) {
                    var dateFormatValue = $dyn.value(control.DateFormat).toLowerCase();
                    if (dateFormatValue !== "auto") {
                        formatInfo.dateFormat = dateFormatValue;
                    }
                }
            };
            var calculateSeparatorFormat = function (formatInfo) {
                if ($dyn.value(control.DateSeparator)) {
                    if ($dyn.value(control.DateSeparator).toLowerCase() !== "auto") {
                        var separatorOne = void 0;
                        var separatorTwo = void 0;
                        var controlDateSeparatorValue = void 0;
                        // If any of the separators are a space, that is communicated from the server as "(space)".  Replace that with a space character.
                        // If any of the separators are null, that is communicated from the server as "(none)".  Replace that with a none character 'n' which later replaces with empty char.
                        var noneChar = "n";
                        if ($dyn.value(control.DateSeparator)) {
                            controlDateSeparatorValue = $dyn.value(control.DateSeparator).replace(/\(space\)/gi, " ").replace(/\(none\)/gi, noneChar);
                        }
                        separatorOne = controlDateSeparatorValue.substr(0, 1);
                        separatorTwo = controlDateSeparatorValue.substr(1, 1);
                        if (separatorOne === noneChar) {
                            separatorOne = "";
                        }
                        if (separatorTwo === noneChar) {
                            separatorTwo = "";
                        }
                        formatInfo.dateSeparators = [separatorOne, separatorTwo];
                    }
                }
            };
            var createDateFormatPattern = function (formatInfo, parseOnlyFormat) {
                if (parseOnlyFormat === void 0) { parseOnlyFormat = false; }
                var formatPatternPartsLength = 5;
                var showDayAs = formatInfo.dayAs;
                var showMonthAs = formatInfo.monthAs;
                var showYearAs = formatInfo.yearAs;
                var dateFormatValue = formatInfo.dateFormat;
                var displayDateFormatParts = new Array(formatPatternPartsLength);
                var datePickerFormatParts = new Array(formatPatternPartsLength);
                for (var i = 0; i < 3; i++) {
                    var formatPartIdentifier = dateFormatValue.substr(i, 1);
                    var formatArrayIndex = i * 2;
                    switch (formatPartIdentifier.toLowerCase()) {
                        case "d":
                            displayDateFormatParts[formatArrayIndex] = showDayAs;
                            datePickerFormatParts[formatArrayIndex] = showDayAs.toLowerCase();
                            break;
                        case "m":
                            displayDateFormatParts[formatArrayIndex] = showMonthAs;
                            datePickerFormatParts[formatArrayIndex] = (showMonthAs.length <= 2) ? showMonthAs.toLowerCase() : showMonthAs.substr(0, showMonthAs.length - 2);
                            break;
                        case "y":
                            displayDateFormatParts[formatArrayIndex] = showYearAs;
                            datePickerFormatParts[formatArrayIndex] = showYearAs.substr(0, showYearAs.length / 2).toLowerCase();
                            break;
                    }
                }
                var inxFormatPartOne = 0;
                var inxSeparatorOne = 1;
                var inxFormatPartTwo = 2;
                var inxSeparatorTwo = 3;
                var inxFormatPartThree = 4;
                var formatDelimiterOne = (!displayDateFormatParts[inxFormatPartOne] ||
                    (!displayDateFormatParts[inxFormatPartTwo] && !displayDateFormatParts[inxFormatPartThree])) ? "" : formatInfo.dateSeparators[0];
                var formatDelimiterTwo = (!displayDateFormatParts[inxFormatPartTwo] || !displayDateFormatParts[inxFormatPartThree]) ? "" : formatInfo.dateSeparators[1];
                displayDateFormatParts[inxSeparatorOne] = formatDelimiterOne;
                displayDateFormatParts[inxSeparatorTwo] = formatDelimiterTwo;
                datePickerFormatParts[inxSeparatorOne] = formatDelimiterOne;
                datePickerFormatParts[inxSeparatorTwo] = formatDelimiterTwo;
                if (!parseOnlyFormat) {
                    // Parse only format indicates a secondary parse format is being
                    // calculated so don't update the datepicker format in that case.
                    // We currently set the datePickerFormatPattern directly on the control.
                    control.datePickerFormatPattern = datePickerFormatParts.join("");
                    control.momentDatePickerOpenFormatPattern = displayDateFormatParts.join("");
                }
                // The new format string will be returned and used by the control;
                return displayDateFormatParts.join("");
            };
            var createCondensedDateFormatPatterns = function (formatInfo) {
                var formats = [];
                var baseFormat = "";
                for (var i = 0; i < 3; i++) {
                    var formatPartIdentifier = formatInfo.dateFormat.substr(i, 1);
                    switch (formatPartIdentifier.toLowerCase()) {
                        case "d":
                            baseFormat += formatInfo.dayAs ? "DD" : "";
                            break;
                        case "m":
                            baseFormat += formatInfo.monthAs ? "MM" : "";
                            break;
                        case "y":
                            baseFormat += formatInfo.monthAs ? "YY" : "";
                            break;
                    }
                }
                if (baseFormat) {
                    formats.push(baseFormat);
                    if (baseFormat.match(/YY/)) {
                        // If the condensed format supports years support both 2 and 4 digit versions.
                        formats.push(baseFormat.replace(/YY/, "YYYY"));
                    }
                }
                return formats;
            };
            // Get the cultural defaults(Auto values) and then update them
            // with overrides for this control instance.
            var formatInfo = getCultureDefaults();
            calculateDayFormat(formatInfo);
            calculateMonthFormat(formatInfo);
            calculateYearFormat(formatInfo);
            calculateSeparatorFormat(formatInfo);
            calculateDateFormat(formatInfo);
            var display = createDateFormatPattern(formatInfo);
            var parse;
            var yearAs = formatInfo.yearAs;
            if (yearAs !== "") {
                // If we have years shown allow both 2 and 4 digit year for parsing.
                // For this to work moment needs to have the 2 digit version as the
                // first parse format, otherwise Dates like 8/16/15 get treated as
                // 8/16/0015 instead of 8/16/2015
                formatInfo.yearAs = "YY";
                parse = [createDateFormatPattern(formatInfo, true)];
                formatInfo.yearAs = "YYYY";
                parse.push(createDateFormatPattern(formatInfo, true));
            }
            else {
                parse = [display];
            }
            if (yearAs !== "" && (formatInfo.monthAs !== "" || formatInfo.dayAs !== "")) {
                // If the format will contain a year and more data than just the year make the year optional by providing a second format without it.
                formatInfo.yearAs = "";
                parse.push(createDateFormatPattern(formatInfo, true));
            }
            formatInfo.yearAs = yearAs;
            var condensedParse = createCondensedDateFormatPatterns(formatInfo);
            return { display: display, parse: parse, condensedParse: condensedParse };
        }
        util.getDateFormat = getDateFormat;
        /**
         * Gets the spearator that should be used between components of time for the specified control
         * @param control The specified control
         * @returns The time separator as a string
         */
        function getTimeSeparator(control) {
            return $dyn.util.timeSeparators[$dyn.value(control.TimeSeparator).toLocaleLowerCase()].toString();
        }
        util.getTimeSeparator = getTimeSeparator;
        /**
         * Gets time format information for the specified control.
         * @param control The specified control
         * @returns An object containing display and parse formats.
         * @remarks
         * The display format is a simple string,
         * but the parse format is an array of possible formats to try when parsing.
         */
        function getTimeFormat(control) {
            // Build up a time format pattern based on various control settings such as whether hours are shown, if time is am/pm vs 24 hour, etc.
            // Check if the default time format contains an upper case "H", which means this culture uses 24 hour time.
            var is24HourCultureDefault = Globalize.culture().calendar.patterns.t.indexOf("H") !== -1;
            var is24HourTime = $dyn.value(control.TimeFormat).toLowerCase() === "auto" ? is24HourCultureDefault : $dyn.value(control.TimeFormat).toLowerCase() === "hour24";
            var timeConfig = {
                Is24HourTime: is24HourTime,
                TimeHours: $dyn.value(control.TimeHours),
                TimeMinutes: $dyn.value(control.TimeMinute),
                TimeSeconds: $dyn.value(control.TimeSeconds),
                TimeSeparator: $dyn.util.getTimeSeparator(control)
            };
            var getFormatString = function (config) {
                var showHoursAs = config.Is24HourTime ? "HH" : "hh";
                showHoursAs = config.TimeHours ? (showHoursAs + config.TimeSeparator) : "";
                var showMinutesAs = config.TimeMinutes ? ("mm" + config.TimeSeparator) : "";
                var showSecondsAs = config.TimeSeconds ? "ss" : "";
                var showAmPmAs = config.Is24HourTime || !showHoursAs ? "" : " A";
                // Check if Seconds and Minutes are empty. If so, we remove timeSeparator for Minutes and Hours correspondingly
                if (!showSecondsAs) {
                    showMinutesAs = showMinutesAs.endsWith(config.TimeSeparator) ? showMinutesAs.substr(0, showMinutesAs.length - config.TimeSeparator.length) : showMinutesAs;
                }
                if (!showMinutesAs) {
                    showHoursAs = showHoursAs.endsWith(config.TimeSeparator) ? showHoursAs.substr(0, showHoursAs.length - config.TimeSeparator.length) : showHoursAs;
                }
                return showHoursAs + showMinutesAs + showSecondsAs + showAmPmAs;
            };
            var display = getFormatString(timeConfig);
            var parse = [display];
            if (timeConfig.TimeHours) {
                // If we are entering hours, also support 24 hour time or AMPM as a secondary parse format.
                timeConfig.Is24HourTime = !timeConfig.Is24HourTime;
                parse.push(getFormatString(timeConfig));
            }
            return { display: display, parse: parse };
        }
        util.getTimeFormat = getTimeFormat;
        /**
         * Shows the date picker for the specified input element and the specified Date/DateTime control.
         * @param inputElement The html element to attach the jquery datepicker to
         * @param control The specified control
         */
        function showDatePicker(inputElement, control) {
            // Flag used when we are closing to know if we should take the value from the picker. Set to false by our today/clear/maxdate buttons.
            var shouldUpdateControlValue = true;
            var updateControlValue = function (selectedDate, forceChange) {
                if (forceChange === void 0) { forceChange = false; }
                // If a date is not passed in, get it from the datepicker.
                var pickerDate = selectedDate ? selectedDate : inputElement.datepicker("getDate");
                if (pickerDate) {
                    // The picked value will be in the machine timezone, but moment from the control will have
                    // the correct timezone so update it with the new date and use it's existing time.
                    var controlMoment = control.getMoment();
                    if (!controlMoment || !controlMoment.isValid()) {
                        controlMoment = control.getSessionDateMoment().startOf("day");
                    }
                    controlMoment.year(pickerDate.getFullYear());
                    controlMoment.month(pickerDate.getMonth());
                    controlMoment.date(pickerDate.getDate());
                    control.pickerOpen(false);
                    inputElement.val(controlMoment.format(control.displayFormat()));
                    control.updateValue(false, forceChange);
                }
            };
            var closePickerWithoutTakingValue = function () {
                // Control value has been updated. Make sure the picker
                // closing doesn't override the value.
                shouldUpdateControlValue = false;
                inputElement.datepicker("hide");
                // Focus the control again.
                inputElement.focus();
            };
            var buttonPanelTelemetry = function (buttonLabel) {
                var clickTelemetryEventArgs;
                var clickEventCategory = $dyn.telemetry.ActionEvents.buttonClicked;
                var clickOptions = { inputType: $dyn.telemetry.InputType.mouse, extendedData: buttonLabel };
                clickTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, clickTelemetryEventArgs, clickEventCategory, clickOptions);
            };
            var datePickerDestroyHandler;
            var datePickerTabbingContainerHandlerDispose;
            var createDatePickerDestoryHandler = function (maxDate, clear, today) {
                return function () {
                    inputElement.off("keydown.picker");
                    if (maxDate) {
                        maxDate.off("click");
                    }
                    if (clear) {
                        clear.off("click");
                    }
                    if (today) {
                        today.off("click");
                    }
                };
            };
            // Access the format patterns, since in some case where there is no data, the logic to set up the datePickerFormatPattern may not have been run.
            control.displayFormat();
            // Construct the year range in the format the date picker options expect.
            // The getDate api returns the year minus 1900, so we add that back
            // to get the full year. This string is not shown to the user and should
            // not go through globalize for formatting.
            var yearRange = $dyn.util.time.minDate.getFullYear() + ":" + $dyn.util.time.maxDate.getFullYear();
            var culture = Globalize.culture();
            var monthAfterYear = control.datePickerFormatPattern.toLowerCase().indexOf("m") > control.datePickerFormatPattern.toLowerCase().indexOf("y");
            var sessionUserMoment = control.getSessionDateMoment();
            var sessionMoment = moment({
                day: sessionUserMoment.date(),
                month: sessionUserMoment.month(),
                year: sessionUserMoment.year(),
            });
            var sessionMomentAsDate = sessionMoment.toDate();
            var updateDateAttributes = function () {
                $widget.find(".ui-datepicker-calendar td a").each(function (i, dateElement) {
                    var dateLabel = [];
                    var tdElement = $(dateElement).parent();
                    var weekDayIdx = tdElement.parent().children().index(tdElement);
                    var weekDay = culture.calendar.days.names[weekDayIdx];
                    dateLabel.push(weekDay);
                    var date = $(dateElement).text();
                    var monthIdx = parseInt(tdElement.attr("data-month"), 10);
                    var month = culture.calendar.months.names[monthIdx];
                    dateLabel.push(date);
                    dateLabel.push(month);
                    var year = tdElement.attr("data-year");
                    dateLabel.push(year);
                    var todayButtonLabel = control.getTodayButtonLabel();
                    if ($(dateElement)[0].parentElement.title === todayButtonLabel) {
                        dateLabel.push(todayButtonLabel);
                    }
                    $(dateElement).attr("aria-label", dateLabel.join(", "));
                    $(dateElement).attr("role", "button");
                    $(dateElement).attr("href", "#!");
                    $(dateElement).attr("id", "idDay-" + $(dateElement)[0].text);
                });
                // set Month
                var monthElement = $widget.find(".ui-datepicker-month");
                $(monthElement).attr("aria-label", $dyn.label("Input_DatePickerMonthLabel"));
                // set Year
                var yearElement = $widget.find(".ui-datepicker-year");
                $(yearElement).attr("aria-label", $dyn.label("Input_DatePickerYearLabel"));
            };
            var datePickerOptions = {
                buttonImageOnly: true,
                changeMonth: true,
                changeYear: true,
                dateFormat: control.datePickerFormatPattern,
                dayNames: culture.calendar.days.names,
                dayNamesMin: culture.calendar.days.namesShort,
                dayNamesShort: culture.calendar.days.namesAbbr,
                defaultDate: sessionMomentAsDate,
                // note since we set RTL on the body - we do not set the datepicker isRTL flag.
                firstDay: culture.calendar.firstDay,
                maxDate: $dyn.util.time.maxDate,
                minDate: $dyn.util.time.minDate,
                monthNames: culture.calendar.months.names,
                monthNamesShort: culture.calendar.months.namesAbbr,
                nextText: $dyn.label("Input_DatePickerNextMonth"),
                prevText: $dyn.label("Input_DatePickerPreviousMonth"),
                // Setting the datepicker shortyear cutoff to match moment's default value
                shortYearCutoff: shortYearCutoff,
                // Disabling the animation since there is an issue internal to the Datepicker
                // widget that causes an unhandled client exception if a date is double-clicked.
                showAnim: "",
                showMonthAfterYear: monthAfterYear,
                showOn: "button",
                yearRange: yearRange,
                beforeShow: function (input, inst) {
                    // bind to scroll event of the datePicker scrollable parent in order to close the datepicker on scroll
                    var scrollParent = inputElement.scrollParent();
                    inputElement.scrollParents = [];
                    while (scrollParent.length > 0 && scrollParent[0] !== document) {
                        // store the scroll parent to use for unbinding on close
                        inputElement.scrollParents.push(scrollParent);
                        scrollParent.on("scroll.datePicker", closePickerWithoutTakingValue);
                        scrollParent = scrollParent.scrollParent();
                    }
                    setTimeout(function () {
                        // update month next , prev to role="button"
                        $(".ui-datepicker-next").attr("role", "button");
                        $(".ui-datepicker-prev").attr("role", "button");
                        // set the cells wrapper to be presentation
                        $(".ui-datepicker-calendar [data-handler='selectDay']").attr("role", "presentation");
                    }, 10);
                    var updateTimeTimeout;
                    var $widget = inputElement.datepicker("widget");
                    inputElement.on("keydown.ariaAlert", function (event) {
                        if ($dyn.util.isShortcutKeyPressed(event, {
                            ctrl: true,
                            keyCode: [$dyn.ui.KeyCodes.leftArrow, $dyn.ui.KeyCodes.rightArrow, $dyn.ui.KeyCodes.upArrow, $dyn.ui.KeyCodes.downArrow]
                        })) {
                            if (updateTimeTimeout) {
                                clearTimeout(updateTimeTimeout);
                            }
                            updateTimeTimeout = window.setTimeout(function () {
                                updateDateAttributes();
                                var $hoveredDate = $widget.find(".ui-datepicker-calendar td a.ui-state-hover");
                                if ($hoveredDate.length > 0) {
                                    var dateString = $hoveredDate.attr("aria-label");
                                    $dyn.shell.addAriaAlertMessage(dateString);
                                }
                                updateTimeTimeout = null;
                            }, 500);
                        }
                    });
                    return null;
                },
                beforeShowDay: function (date) {
                    if (sessionMoment.isSame(date, "day")) {
                        return [true, "ui-datepicker-usersessiondate", control.getTodayButtonLabel()];
                    }
                    return [true, "", ""];
                },
                onChangeMonthYear: function () {
                    // Assigning aria-label to calendar dates
                    setTimeout(updateDateAttributes, 10);
                    buildButtonPanel();
                },
                onClose: function () {
                    var e_1, _a;
                    inputElement[0].parentElement.removeAttribute("aria-owns");
                    inputElement.removeAttr("aria-activedescendant");
                    inputElement.off("keyup.datePickerButtonPanel keydown.datePickerButtonPanel");
                    inputElement.off("keydown.ariaAlert");
                    if ($widget) {
                        $widget.off("keydown");
                    }
                    if (shouldUpdateControlValue && inputElement.datepicker("getDate")) {
                        // Take the value from the picker on close in case the user
                        // updated the input by typing a new value.
                        updateControlValue();
                    }
                    // remove tabbing container
                    if (datePickerTabbingContainerHandlerDispose) {
                        datePickerTabbingContainerHandlerDispose();
                        datePickerTabbingContainerHandlerDispose = undefined;
                    }
                    // Destroy the picker so our buttons we added below are properly removed.
                    try {
                        inputElement.datepicker("destroy");
                        $(document.body).trigger("datePickerDestroy");
                    }
                    catch (e) {
                        $dyn.telemetry.addControlErrorEvent(control, "Error_DestoryingDatePicker", e.stack);
                    }
                    $(document.body).off("datePickerDestroy", datePickerDestroyHandler);
                    datePickerDestroyHandler = null;
                    control.updatingBlock(function () {
                        control.pickerOpen(false);
                        // Make sure that the input has the correct date and time showing according to the display format instead of the picker format.
                        control.formattedValue.valueChanged.raise();
                    });
                    // unbind scroll events
                    if (inputElement.scrollParents) {
                        try {
                            for (var _b = __values(inputElement.scrollParents), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var scrollParent = _c.value;
                                scrollParent.off("scroll.datePicker");
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        inputElement.scrollParents = [];
                    }
                },
                onSelect: function (dateText, datePicker) {
                    // There is an edge case where if the user types a new date and
                    // hits enter, the datepicker get the wrong value if you call
                    // the datepicker with the 'getDate' argument. To avoid this we
                    // create the right JS Date object using the information about
                    // the selected date.
                    var selectedDate = new Date(datePicker.selectedYear, datePicker.selectedMonth, datePicker.selectedDay);
                    updateControlValue(selectedDate, true);
                    closePickerWithoutTakingValue();
                },
            };
            // This is a custom setting option
            datePickerOptions.localToday = sessionMomentAsDate;
            inputElement.datepicker(datePickerOptions);
            inputElement.off("keypress", $.datepicker._doKeyPress);
            // When some keyboard shortcuts are used the button panel is removed, recreate it.
            // Since the picker does the shortcuts on keydown use that event, but also handle
            // keyup for cases where the user types a new value.
            inputElement.on("keyup.datePickerButtonPanel keydown.datePickerButtonPanel", buildButtonPanel);
            var $widget = inputElement.datepicker("widget");
            $widget.addClass("datepicker-popup");
            $widget.attr("role", "dialog");
            // Add the binding-focusRegion class so the datepicker works well with flyouts
            // since it doesn't use the normal flyout handler
            $widget.addClass("binding-focusRegion");
            // We need to give the DatePicker a tab-index and a keydown handler to
            // prevent case where the user interacts with the picker using a mouse
            // and focus leaves the input. Without the tabindex clicking in whitespace
            // changes the active element to the body, but then shortcuts like ESC are
            // consumed by the shell rather than the datepicker. To prevent this we let
            // the picker recieve focus and have it handle the ESC shortcut.
            $widget.attr("tabindex", "0");
            $widget.on("keydown", function (e) {
                if ($dyn.util.isShortcutKeyPressed(e, { keyCode: $dyn.ui.KeyCodes.esc })) {
                    e.stopPropagation();
                    // There wasn't a button click, but this will close the picker and not persist any new values.
                    closePickerWithoutTakingValue();
                }
                else if ($dyn.util.isShortcutKeyPressed(e, { keyCode: [$dyn.ui.KeyCodes.enter, $dyn.ui.KeyCodes.spacebar] })) {
                    e.stopPropagation();
                    var selectedDateElement = void 0;
                    var parentElement = void 0;
                    if (e.target && e.target.parentElement) {
                        selectedDateElement = e.target;
                        parentElement = selectedDateElement.parentElement;
                    }
                    if (selectedDateElement && parentElement && parentElement.getAttribute("data-handler") === "selectDay") {
                        var selectedDate = new Date(parseInt(parentElement.getAttribute("data-year"), 10), parseInt(parentElement.getAttribute("data-month"), 10), parseInt(selectedDateElement.innerText, 10));
                        updateControlValue(selectedDate, true);
                        closePickerWithoutTakingValue();
                    }
                }
            });
            $widget.on("keyup", function (e) {
                if ($dyn.util.isShortcutKeyPressed(e, { keyCode: $dyn.ui.KeyCodes.tab, isShiftKeyAgnostic: true })) {
                    // update activedescendant
                    if (e.target.classList.contains("ui-state-default")) {
                        inputElement.attr("aria-activedescendant", e.target.id);
                    }
                }
            });
            if ($dyn.value(control.IsValid)) {
                var controlMoment = control.getMoment();
                if (controlMoment && controlMoment.isValid()) {
                    // The control date is correct for the control timezone,
                    // but we need a date that is correct for the browser timezone since that is what the jquery datepicker uses.
                    // When the date is invalid such as when the date is an empty string, the date is not set and the date picker will default to today's date
                    inputElement.datepicker("setDate", new Date(controlMoment.year(), controlMoment.month(), controlMoment.date()));
                    control.valueBinder.notifyCommitted();
                    var isMaxDate = ((control.IgnoreTime && controlMoment.isSame($dyn.util.time.maxDate, "day")) || (!control.IgnoreTime && controlMoment.isSame($dyn.util.time.maxDate)));
                    // If user has selected max date open the date picker with todays date so it is easier for them to select a more appropiate date
                    if (isMaxDate) {
                        window.setTimeout(function () {
                            // Need to wait for the datepicker to be built
                            $.datepicker._gotoToday(inputElement);
                        });
                    }
                }
                else {
                    // if invalid date, then set date so the picker opens to 'today'
                    var defaultDate = control.getSessionDateMoment();
                    inputElement.datepicker("setDate", new Date(defaultDate.year(), defaultDate.month(), defaultDate.date()));
                    control.valueBinder.notifyCommitted();
                }
            }
            inputElement.datepicker("show");
            inputElement[0].parentElement.setAttribute("aria-owns", "ui-datepicker-div");
            control.pickerOpen(true);
            // Build up the buttons which should appear in the button panel. The
            // jQuery calendar control rebuilds the button panel whenever the
            // calender month changes, so we need to do the same.
            function buildButtonPanel() {
                // The onChangeMonthYear event fires too early, before the calendar
                // HTML is rebuilt. We need this to run *after* the rest of the HTML
                // has been rebuilt, so we have to do this in a timeout.
                $dyn.async(function () {
                    var $datePickerButtonPane = $("<div class='ui-datepicker-buttonpane ui-widget-content' />");
                    var $widget = inputElement.datepicker("widget");
                    $widget.find(".ui-datepicker-buttonpane").remove();
                    $widget.append($datePickerButtonPane);
                    $widget.find(".ui-datepicker-calendar").addClass("ui-datepicker-hasButtonPane");
                    inputElement.on("keydown.picker", function (evt) {
                        if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.ui.KeyCodes.letterT })) {
                            evt.preventDefault();
                            if ($todayLabelElement) {
                                if (control.isSessionDateToday()) {
                                    $todayLabelElement.click();
                                }
                                else {
                                    // The 'Session Date' button is present and not the today button
                                    // So do the same thing as the button click but use TodayMoment instead of SessionDateMoment
                                    control.updatingBlock(function () {
                                        // if present, the "today" button should preserve the existing time, otherwise set to midnight
                                        // set the control date and the input control text to the formatted representation of that date
                                        // then fire the event that fires when picking a date using the picker
                                        var controlMoment = control.getTodayMoment();
                                        control.setDate(controlMoment.toDate());
                                        // Tell the control the picker closed or else we get the wrong format.
                                        control.pickerOpen(false);
                                        var newFormattedValue = control.getFormattedValue(true);
                                        control._lastUserValue = newFormattedValue;
                                        inputElement.val(newFormattedValue);
                                    });
                                    evt.stopImmediatePropagation();
                                    closePickerWithoutTakingValue();
                                }
                            }
                        }
                        else if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.ui.KeyCodes.letterD })) {
                            evt.preventDefault();
                            if ($todayLabelElement) {
                                $todayLabelElement.click();
                            }
                        }
                        else if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.ui.KeyCodes.letterN })) {
                            evt.preventDefault();
                            if ($maxDateLabelElement) {
                                $maxDateLabelElement.click();
                            }
                        }
                        else if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.ui.KeyCodes.letterC })) {
                            evt.preventDefault();
                            if ($clearLabelElement) {
                                $clearLabelElement.click();
                            }
                        }
                    });
                    var $maxDateLabelElement;
                    var maxDateLabel = $dyn.value(control.MaxDateLabel);
                    if (maxDateLabel) {
                        // Create and add the max date button.
                        $maxDateLabelElement = $("<button/>");
                        $maxDateLabelElement.addClass("ui-datepicker-maxdatelabel ui-state-default ui-priority-secondary ui-corner-all");
                        $maxDateLabelElement.attr("type", "button");
                        $maxDateLabelElement.text(maxDateLabel);
                        $datePickerButtonPane.append($maxDateLabelElement);
                        $maxDateLabelElement.click(function () {
                            buttonPanelTelemetry(maxDateLabel);
                            control.updatingBlock(function () {
                                // Set the control date to our max date and the input control text to the formatted representation of that date
                                // then fire the event that fires when picking a date using the picker
                                control.setDate($dyn.util.time.maxDate);
                                control.pickerOpen(false);
                                var newFormattedValue = control.getFormattedValue(true);
                                control._lastUserValue = newFormattedValue;
                                inputElement.val(newFormattedValue);
                            });
                            closePickerWithoutTakingValue();
                        });
                    }
                    // Remove original Clear button to make a room for our own Clear button below
                    $datePickerButtonPane.find(".ui-datepicker-close").detach();
                    // Create and add the clear button.
                    var $clearLabelElement = $("<button/>");
                    $clearLabelElement.addClass("ui-datepicker-clearlabel ui-state-default ui-priority-secondary ui-corner-all");
                    $clearLabelElement.attr("type", "button");
                    $clearLabelElement.text($dyn.label("Input_DatePickerClear"));
                    $datePickerButtonPane.append($clearLabelElement);
                    $clearLabelElement.click(function () {
                        buttonPanelTelemetry($dyn.label("Input_DatePickerClear"));
                        control.pickerOpen(false);
                        control.formattedValue("", true);
                        closePickerWithoutTakingValue();
                    });
                    // Remove original Today button to make a room for our own Today button
                    $datePickerButtonPane.find(".ui-datepicker-current").detach();
                    // Create and add the today button.
                    var $todayLabelElement = $("<button/>");
                    $todayLabelElement.addClass("ui-datepicker-todaylabel ui-state-default ui-priority-secondary ui-corner-all");
                    $todayLabelElement.attr("type", "button");
                    $todayLabelElement.text(control.getTodayButtonLabel());
                    $datePickerButtonPane.append($todayLabelElement);
                    $todayLabelElement.click(function () {
                        buttonPanelTelemetry(control.getTodayButtonLabel());
                        control.updatingBlock(function () {
                            // if present, the "today" button should preserve the existing time, otherwise set to midnight
                            // set the control date and the input control text to the formatted representation of that date
                            // then fire the event that fires when picking a date using the picker
                            var controlMoment = control.getSessionDateMoment();
                            control.setDate(controlMoment.toDate());
                            // Tell the control the picker closed or else we get the wrong format.
                            control.pickerOpen(false);
                            var newFormattedValue = control.getFormattedValue(true);
                            control._lastUserValue = newFormattedValue;
                            inputElement.val(newFormattedValue);
                        });
                        closePickerWithoutTakingValue();
                    });
                    if (datePickerDestroyHandler) {
                        $(document.body).off("datePickerDestroy", datePickerDestroyHandler);
                        datePickerDestroyHandler = null;
                    }
                    datePickerDestroyHandler = createDatePickerDestoryHandler($maxDateLabelElement, $clearLabelElement, $todayLabelElement);
                    // setup tabbing region we do this here as we need the picker rendered
                    if (datePickerTabbingContainerHandlerDispose) {
                        datePickerTabbingContainerHandlerDispose();
                        datePickerTabbingContainerHandlerDispose = undefined;
                    }
                    datePickerTabbingContainerHandlerDispose = $dyn.util.tabbingContainer($widget[0], $dyn.label("datePicker"), false, true);
                    $(document.body).on("datePickerDestroy", datePickerDestroyHandler);
                }, undefined, "Build date picker button panel");
            }
            // Build the button panel for the initial showing. We need to do this in
            // case no date is present since then onChangeMonthYear will not be called.
            buildButtonPanel();
        }
        util.showDatePicker = showDatePicker;
    })(util = $dyn.util || ($dyn.util = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=DateTimeHelpers.js.map
